// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"f655262b","659":"b7cfa9e7"}[chunkId] + ".chunk.js";
};